module.exports = __webpack_public_path__ + "8baf94fce0f9395e28b0b6504b67ba38.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_l_40.mp3
// module id = 441
// module chunks = 0